import { Component, Inject, OnInit, signal } from '@angular/core';
import { TourWithOrgSiteKey } from '@app/stores/toursStore';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorHandler } from '@app/core/services/error-handler.service';
import { ToursService } from '../../../../api/services/tours.service';
import { lastValueFrom, Observable } from 'rxjs';
import { BinaryFileType } from '../../../../api/models/binary-file-type';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/list';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
    selector: 'app-view-tour-dialog',
    templateUrl: './view-tour-dialog.component.html',
    styleUrls: ['./view-tour-dialog.component.scss'],
    imports: [
        MatIconButton,
        MatTooltip,
        MatIcon,
        MatDialogClose,
        MatDivider,
        NgxExtendedPdfViewerModule,
        TranslateModule,
    ],
})
export class ViewTourDialogComponent implements OnInit {
    tour: TourWithOrgSiteKey;
    currentlyViewedPdf = signal<Blob | undefined>(undefined);

    constructor(
        @Inject(MAT_DIALOG_DATA)
        private data: {
            tour: TourWithOrgSiteKey;
            organizationSiteKey: string;
            context: 'consignor' | 'carrier' | 'consignee';
        },
        private translateService: TranslateService,
        private spinner: NgxSpinnerService,
        private tourService: ToursService,
        private errorHandler: ErrorHandler
    ) {}

    async ngOnInit() {
        this.tour = this.data.tour;
        if (this.tour.deliveryNoteKeys.length) {
            await this.loadTour();
        }
    }

    async loadTour(): Promise<void> {
        try {
            const blobData = await lastValueFrom(
                this.getBlobObservableForContext(this.data.context)!
            );

            this.currentlyViewedPdf.set(blobData);
        } catch (error) {
            this.translateService.instant('GLOBAL.ERROR.UNSPECIFIED');
        }
    }

    async downloadTour(): Promise<void> {
        try {
            await this.spinner.show();
            const url = window.URL.createObjectURL(this.currentlyViewedPdf()!);
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.href = url;
            const bundleNumber = this.tour.tourNumber;
            a.download = bundleNumber.replace('.', '-') + '.pdf';
            a.click();
        } catch (error) {
            this.errorHandler.handleError(error);
        } finally {
            await this.spinner.hide();
        }
    }

    getBlobObservableForContext(
        context: string
    ): Observable<BinaryFileType> | undefined {
        switch (context) {
            case 'carrier':
                return this.tourService.getToursPdfs({
                    organizationSiteKey: this.data.organizationSiteKey,
                    tourKey: this.tour._key,
                });
            case 'consignee':
                return this.tourService.getToursPdfs({
                    organizationSiteKey: this.data.organizationSiteKey,
                    tourKey: this.tour._key,
                });
        }

        return undefined;
    }
}
